import { render, staticRenderFns } from "./WordForm.vue?vue&type=template&id=14f209f2&scoped=true&"
import script from "./WordForm.vue?vue&type=script&lang=js&"
export * from "./WordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f209f2",
  null
  
)

export default component.exports